export enum Status {
  Submitted = "submitted",
  UnderReview = "underReview",
  Approved = "approved",
  Declined = "declined",
  Active = "active",
  ExternalUnverified = "EXTERNAL_UNVERIFIED",
  ExternalVerified = "EXTERNAL_VERIFIED",
  ExternalApproved = "EXTERNAL_APPROVED",
  ExternalActive = "EXTERNAL_ACTIVE",
  ExternalSubmitted = "EXTERNAL_SUBMITTED",
  ExternalRejected = "EXTERNAL_REJECTED",
  ExternalExpired = "EXTERNAL_EXPIRED",
  ExternalDeclined = "EXTERNAL_DECLINED",
  ExternalPending = "EXTERNAL_PENDING",
  ExternalUnderReview = "EXTERNAL_UNDER_REVIEW",
}

export const StatusText: Record<string, string> = {
  "ACTIVE": "Active",
  "UNDER REVIEW": "Under Review",
  "REJECTED": "Rejected",
  "CANCELLED": "Cancelled",
  "EXPIRED": "Expired",
  "INACTIVE": "Inactive",
};

export const StatusClass: Record<string, string> = {
  "ACTIVE": "chip-success",
  "APPROVED": "chip-success",
  "REJECTED": "chip-error",
  "CANCELLED": "chip-error",
  "EXPIRED": "chip-error",
  "INACTIVE": "chip-error",
  "UNDER REVIEW": "chip-pending",
}

// policy-coverage.constants.ts

export enum CoverageType {
  PersonalProperty = "Personal Property",
  PersonalLiability = "Personal Liability",
  MedicalPayments = "Medical Payments",
  LossOfUse = "Loss of Use",
}

export const CoverageIcons: Record<CoverageType, string> = {
  [CoverageType.PersonalProperty]: "home",
  [CoverageType.PersonalLiability]: "liability",
  [CoverageType.MedicalPayments]: "medical",
  [CoverageType.LossOfUse]: "umbrella",
};
